/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { call, put, takeLatest } from "redux-saga/effects";
import { textRequested, textsFailed, textsSucceeded } from "./slice";

import { getErrorMessage } from "Utils/errorUtils";
import { createRequest } from "Utils/requestUtils";

interface Texts {
  [key: string]: any;
}

async function fetchBackupTexts(): Promise<Texts> {
  return import("../../texts.json").then((module) => module.default);
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function* fetchTexts({ payload }: ReturnType<typeof textRequested>) {
  try {
    const { data } = yield call(createRequest, {
      url: `https://api.storebrand.no/open/content/texts/${payload}`,
      params: { version: window.env.FMS_TRANSLATION_VERSION },
    });
    yield put(textsSucceeded(data));
  } catch (e) {
    try {
      const data: Texts = yield call(fetchBackupTexts);
      yield put(textsSucceeded(data));
    } catch (fetchBackupTextsError) {
      yield put(
        textsFailed(
          getErrorMessage(
            fetchBackupTextsError,
            "Unknown error fetching FMS texts",
          ),
        ),
      );
    }
  }
}

export function* textSaga() {
  yield takeLatest(textRequested, fetchTexts);
}
